const parseHeaderTitle = (title) => title.replace(/\|/gi, '\n');

const parseFieldStyles = (fs) => {
    let header = {};
    let cell = {};
    const rules = fs.split(';');
    for(let i in rules){
        const rule = rules[i];
        const [key, value] = rule.split(':');
        if (key === 'hd-color') {
            header = {...header, color: value};
        }
        if (key === 'hd-bgcolor') {
            header = {...header, background: value};
        }
        if (key === 'text-color') {
            cell = {...cell, color: value};
        }
        if (key === 'text-bgcolor') {
            cell = {...cell, background: value};
        }
        if (key === 'hd-align') {
            header = {...header, textAlign: value};
            cell = {...cell, textAlign: value};
        }
    }
    return {
        header,
        cell
    }
}

const parseFieldSettings = (fs) => {
    const result = {};
    if (fs && fs.Style) {
        const settings = fs.Style.split(',');
        for (let i in settings) {
            const s = settings[i];
            const [key,value] = s.split(':');
            result[key] = value;
        };
    }
    return result;
}

const parseField = (field, fieldsStyles = {}, fields) => {
    const settings = parseFieldSettings(field);
    let _fields = null;
    if (fields) {
        _fields = fields.map(f => parseField(f))
    }

    return {
        name: field.Name,
        title: parseHeaderTitle(field.Title),
        isFrozen: field.IsFrozen,
        isNodeKeeper: field.Action.Raw === 'nodekeeper',
        style: fieldsStyles[field.Name],
        tooltip: settings.fieldtip || null,
        editorMethod: field.EditorMethod,
        fieldInfo: _fields || field}
}

export const ParseFieldsInfo = (fieldsInfo, hiddenColumnList, dataItem) => {

    const _fieldsStyles = {};

    const bands = [];
    const columns = [];
    const frozenColumns = [];
    const columnStylesList = [];
    const columnNamesList = [];

    if (Array.isArray(fieldsInfo)) {

        const fi = [...fieldsInfo].sort((a, b) => (a.ViewNumber > b.ViewNumber) ? 1 : -1);

        for (let i in fi) {
            const field = fi[i];
            let fields = null;
            const action = field.Action;

            if (action.Unite) {
                const children = action.Unite.split(',');
                if (children.length) {
                    bands.push({title: parseHeaderTitle(field.Title), children: children.map(name => {
                        _fieldsStyles[name] = parseFieldStyles(field.Style);
                        return {columnName: name};
                    })});
                }
                continue;
            }

            if (!field.IsHidden || hiddenColumnList.indexOf(field.Name) > -1) {


                if (field.EditorMethod === "Web_MultiLabel") {
                    const ruleValue = dataItem.tryGetValueFromExecRules(field.Name, "ListColForMulti", 0);
                    if (ruleValue) {
                        const fieldsName = ruleValue.split('/');
                        fields = fieldsName.map(fName => dataItem.getFieldInfo(fName));
                    }
                }

                columns.push(parseField(field, _fieldsStyles, fields));

                if (field.IsFrozen) {
                    frozenColumns.push(field.Name);
                }

                columnStylesList.push({ columnName: field.Name, width: field.Width, align: (field.AlignH || 'left').toLowerCase() });

                columnNamesList.push(field.Name);
            }

        }
    }
    return {bands, columns, columnNamesList, frozenColumns, columnStylesList: columnStylesList};
}

export const GetRows = (rows, rowTreeInfo) => {
    const result = [];
    if (Array.isArray(rows) && Array.isArray(rowTreeInfo)) {
        for (let i in rows) {
            const row = rows[i];
            let Show_ContextMenu = false;
            const accessPropsList = ['CanShow_HistVacForm', 'CanShow_HistSalChForm', 'CanShow_HistFixForm', 'CanShow_YBDetailForm', 'CanChange_YBMF'];
            const access = {};
            for(let index in accessPropsList) {
                const fieldName = accessPropsList[index];
                const hasAccess = !!row[fieldName];
                access[fieldName] = hasAccess;
                Show_ContextMenu = Show_ContextMenu || hasAccess;
            };
            access.Show_ContextMenu = Show_ContextMenu;
            result.push({...row, treeInfo: {...rowTreeInfo[i], rowIndex: i}, access});
        }
    }
    return result;
}

export const GetPageProps = (pagePropsDataItem, listForBossPO) => {
    const pageProps_dataItem = pagePropsDataItem.dataTable();
    const listForBossPO_dataItem = listForBossPO.dataTable();
    const firstRowBossPO = listForBossPO_dataItem[0] || {};
    const pageProps = pageProps_dataItem[0] || {};

    const {CanAgreeForm, CanRepForm, Label_MainForm, Label_HistSalChForm, Label_YBDetailForm, Legend_YBDetailForm } = firstRowBossPO;

    return {
        ToAllowSet_TestTabNum: pageProps.ToAllowSet_TestTabNum,
        VisualizeReportScId: pageProps.VisualizeReportScId,
        CanAgreeForm, CanRepForm, Label_MainForm, Label_HistSalChForm, Label_YBDetailForm, Legend_YBDetailForm
    }
}